export default "__VITE_ASSET__DnkvPCqE__"